const SCOPE_DESCRIPTIONS: Record<string, string> = {
    'mcp:read': 'Read your ledgers, values and analytics',
    'mcp:write': 'Add, change and delete values and cash flows on your ledgers (costs credits, as in the app)',
};

/**
 * Returns the plain-language meaning of an OAuth scope.
 * Used where the API sends scope ids only, such as the list of authorized apps.
 */
export function describeOAuthScope(scopeId: string): string {
    return SCOPE_DESCRIPTIONS[scopeId] ?? scopeId;
}
